import { createContext } from 'react';
import { Order } from 'utils/types';

type CartContextType = {
  openCart: () => void;
  closeCart: () => void;
  isCartOpen: boolean;
  order?: Order;
  isCartRefactorEnabled: boolean;
};

const CartContext = createContext<CartContextType>({
  openCart: () => {},
  closeCart: () => {},
  isCartOpen: false,
  order: undefined,
  isCartRefactorEnabled: false,
});

export default CartContext;
